import { Dispatch, FunctionComponent, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Gutter, TextArea } from '@gaiads/telia-react-component-library';
import { ApprovalChainStepApprovalRequestDecisionEnum } from '@cdaas/api-clients/dist/asset-user-openapi';

interface ApproveOrRejectOrderProps {
  mode: ApprovalChainStepApprovalRequestDecisionEnum;
  setCommentOnApproveOrRejection: Dispatch<SetStateAction<string>>;
}

const ApproveOrRejectOrder: FunctionComponent<ApproveOrRejectOrderProps> = ({ mode, setCommentOnApproveOrRejection }) => {
  const [text, setText] = useState('');

  const { t } = useTranslation('approval');

  useEffect(() => {
    setCommentOnApproveOrRejection('');
  }, [setCommentOnApproveOrRejection]);

  return (
    <>
      <BodyText size={'sm'} color={'gray400'}>
        {t(
          mode === ApprovalChainStepApprovalRequestDecisionEnum.Approved
            ? 'ApproveOrRejectOrder.approveHelpText'
            : 'ApproveOrRejectOrder.rejectHelpText',
        )}
      </BodyText>

      <Gutter />

      <TextArea
        value={text}
        label={t('ApproveOrRejectOrder.yourComment')}
        placeholder={t(
          mode === ApprovalChainStepApprovalRequestDecisionEnum.Approved
            ? 'ApproveOrRejectOrder.approvePlaceholder'
            : 'ApproveOrRejectOrder.rejectPlaceholder',
        )}
        onChange={e => {
          setText(e.target.value);
          setCommentOnApproveOrRejection(e.target.value);
        }}
      />
    </>
  );
};

export default ApproveOrRejectOrder;
